// BM-H588, 23 September 2026. The one rule for a client's onboarding signature,
// drawn on the pad or typed as their full name.
//
// Mirrors backend/hub/client_signature.py, which is authoritative. A typed
// signature is compared with the signer's full name on letters only, the same
// test the client care letter signing page and the Terms of Business
// acceptance use, so spacing and punctuation do not defeat it.

export const SIGNATURE_MODES = ["draw", "type"];

export const lettersOnly = (value) =>
  (value || "").trim().toLowerCase().replace(/[^a-z]/g, "");

export function typedSignatureMatches(typed, fullName) {
  const t = lettersOnly(typed);
  return t.length >= 2 && t === lettersOnly(fullName);
}

// The line for the "please complete the following" list, or null if the
// signature is acceptable.
export function signatureProblem({ mode, typedName, fullName, canvasEmpty }) {
  if (mode === "type") {
    if (!(typedName || "").trim()) return "Signature (type your full name)";
    if (!typedSignatureMatches(typedName, fullName)) {
      return "Signature (your typed signature should match your full name)";
    }
    return null;
  }
  return canvasEmpty ? "Signature" : null;
}

// What goes in the payload's `signature` field. The backend works out which
// kind it is from the content, so no separate flag is sent.
export function signaturePayload({ mode, typedName, canvasRef }) {
  if (mode === "type") return (typedName || "").trim();
  return canvasRef.current ? canvasRef.current.toDataURL("image/png") : "";
}
